import React from 'react';
import PropTypes from 'prop-types';

const DIGIT_SEGMENTS = {
  0: ['a', 'b', 'c', 'd', 'e', 'f'],
  1: ['b', 'c'],
  2: ['a', 'b', 'd', 'e', 'g'],
  3: ['a', 'b', 'c', 'd', 'g'],
  4: ['b', 'c', 'f', 'g'],
  5: ['a', 'c', 'd', 'f', 'g'],
  6: ['a', 'c', 'd', 'e', 'f', 'g'],
  7: ['a', 'b', 'c'],
  8: ['a', 'b', 'c', 'd', 'e', 'f', 'g'],
  9: ['a', 'b', 'c', 'd', 'f', 'g'],
};
const ALL_SEGMENTS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

function SevenSegmentDigit({ value, small }) {
  const activeSegments = DIGIT_SEGMENTS[value] || [];

  return (
    <span className={`today-seven-digit${small ? ' today-seven-digit--small' : ''}`} aria-hidden="true">
      {ALL_SEGMENTS.map((segment) => (
        <i
          key={segment}
          className={`today-seven-segment today-seven-segment--${segment}${activeSegments.includes(segment) ? ' is-on' : ''}`}
        />
      ))}
    </span>
  );
}

SevenSegmentDigit.defaultProps = {
  small: false,
};

SevenSegmentDigit.propTypes = {
  value: PropTypes.string.isRequired,
  small: PropTypes.bool,
};

export default SevenSegmentDigit;
